export const FAMILY_SITES = [
  {
    key: 'theMoonEnt',
    url: 'https://themoonent.com',
  },
]
